// Cookie consent banner component
import { useState, useEffect } from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const { grantConsent, revokeConsent, hasConsent, isConsentRequired } = useAnalytics();

  useEffect(() => {
    // Only show banner if consent is required and not yet given
    if (isConsentRequired() && !hasConsent()) {
      setShowBanner(true);
    }
  }, [hasConsent, isConsentRequired]);

  const handleAccept = async () => {
    await grantConsent();
    setShowBanner(false);
  };

  const handleDecline = () => {
    revokeConsent();
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm">
              We use cookies and analytics to improve your experience on our site. By clicking
              "Accept", you consent to our use of cookies and analytics tracking.{' '}
              <a
                href="/privacy-policy"
                className="underline hover:text-gray-300"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white transition-colors"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 rounded-md transition-colors"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
